"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TONProvider = void 0;
const protocol_1 = require("../../protocol");
const utils_1 = require("../../utils");
const media_1 = require("../../utils/media");
const InjectUtils_1 = require("../InjectUtils");
class TONProvider {
    constructor() {
        this.signalChainConnectResult = undefined;
        this.accountChangedTONHandler = null;
    }
    send(request) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                (0, utils_1.logDebug)("TONProvider send request:", (0, utils_1.safeJsonStringify)(request));
                // await this.restoreConnect()//To initialize data in Discover
                let tonParams = null;
                switch (request.method) {
                    case "ton_sendTransaction":
                        if (request.params) {
                            tonParams = {
                                method: "sendTransaction",
                                params: [JSON.stringify(request.params)],
                                id: Date.now().toString()
                            };
                            (0, utils_1.logDebug)("TONProvider tonParams first:", JSON.stringify(tonParams));
                        }
                        break;
                    default:
                        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                }
                if (tonParams) {
                    const resultMe = yield window.okxTonWallet.tonconnect.send(tonParams);
                    (0, utils_1.logDebug)("TONProvider send request result:", (0, utils_1.safeJsonStringify)(resultMe));
                    if (resultMe.error) {
                        throw new protocol_1.OKXConnectError(resultMe.error.code, resultMe.error.message);
                    }
                    return {
                        result: resultMe.result,
                        method: request.method,
                    };
                }
                else {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                }
            }
            catch (error) {
                (0, utils_1.logDebug)("TONProvider encountered an error:", error);
                throw error;
            }
        });
    }
    connectReady() {
        return true;
    }
    restoreConnect() {
        // if (isDevice("mobile") && window.okxTonWallet){
        //     return  window.okxTonWallet.tonconnect.restoreConnection()
        // }
        return Promise.resolve();
    }
    parseConnectResponse(needPop, accountChange, signalChain, connectWalletNameSpace, connectRequestWalletResponse, dappInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let connectChain = [];
                connectWalletNameSpace.forEach(item => {
                    if (item.namespace === protocol_1.NameSpaceKeyTON) {
                        connectChain.push(...item.chains);
                    }
                });
                let addresses = [];
                let extra = {};
                connectChain.forEach((chainStr) => {
                    let currentChain = (0, utils_1.getChainId)(chainStr);
                    let selectedAddress = connectRequestWalletResponse.address.find((addressItem) => {
                        return (addressItem.chainId === "607" && addressItem.coinType === 607)
                            || (addressItem.namespaceChainId === chainStr);
                    });
                    if (selectedAddress) {
                        addresses.push(chainStr + ":" + selectedAddress.address);
                        extra[chainStr] = {
                            publicKey: selectedAddress.publicKey
                        };
                    }
                });
                (0, utils_1.logDebug)("tonprovider parseConnectResponse needPop and addresses: ", needPop, JSON.stringify(addresses));
                if (addresses && addresses.length > 0) {
                    let tonItem = connectWalletNameSpace.find(tonItem => {
                        return tonItem.namespace === protocol_1.NameSpaceKeyTON;
                    });
                    (0, utils_1.logDebug)("tonprovider parseConnectResponse ton: ", JSON.stringify(tonItem));
                    let tonResult = undefined;
                    if (tonItem && tonItem.params && dappInfo && dappInfo.manifestUrl) {
                        this.dappInfo = dappInfo;
                        let itmes = [tonItem.params.ton_addr];
                        let params = {
                            manifestUrl: dappInfo.manifestUrl,
                            items: itmes
                        };
                        let needProof = needPop || accountChange;
                        if (needProof && tonItem.params.ton_proof) {
                            itmes.push(tonItem.params.ton_proof);
                        }
                        (0, utils_1.logDebug)("parseConnectResponse ton connect params: ", JSON.stringify(params));
                        if ((0, media_1.isDevice)("mobile")) {
                            tonResult = (yield window.okxTonWallet.tonconnect.connect(2, params));
                        }
                        else {
                            if (needPop || accountChange) {
                                tonResult = (yield window.okxTonWallet.tonconnect.connect(2, params));
                            }
                            else {
                                //No proof is needed here, the result is only used for address verification
                                tonResult = (yield window.okxTonWallet.tonconnect.restoreConnection());
                            }
                        }
                    }
                    else {
                        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "manifestUrl is nil");
                    }
                    if (signalChain && this.signalChainConnectResult) {
                        tonResult = this.signalChainConnectResult;
                        this.signalChainConnectResult = undefined;
                    }
                    (0, utils_1.logDebug)("parseConnectResponse ton connect result: ", JSON.stringify(tonResult));
                    if (tonResult && tonItem) {
                        if (tonResult.event === "connect_error") {
                            throw new protocol_1.OKXConnectError(tonResult.payload.code, tonResult.payload.message);
                        }
                        else {
                            let ton_addr = tonResult.payload.items.find(item => item.name === "ton_addr");
                            let ton_proof = tonResult.payload.items.find(item => item.name === "ton_proof");
                            (0, utils_1.logDebug)("tonprovider connect isSignalChain: ", signalChain);
                            let nameSpaceResponse = {
                                namespace: protocol_1.NameSpaceKeyTON,
                                addresses: addresses,
                                methods: [...InjectUtils_1.TONMethods],
                                extra: extra,
                                data: {
                                    ton_addr: ton_addr,
                                    ton_proof: ton_proof,
                                    manifestUrl: dappInfo.manifestUrl
                                }
                            };
                            return nameSpaceResponse;
                        }
                    }
                }
                return undefined;
            }
            catch (error) {
                (0, utils_1.logDebug)("tonprovider parseConnectResponse error: ", JSON.stringify(error));
                throw error;
            }
        });
    }
    connect(nameSpace, dappInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            if (nameSpace && dappInfo && dappInfo.manifestUrl && nameSpace.params) {
                this.dappInfo = dappInfo;
                let itmes = [nameSpace.params.ton_addr];
                let params = {
                    manifestUrl: dappInfo.manifestUrl,
                    items: itmes
                };
                if (nameSpace.params.ton_proof) {
                    itmes.push(nameSpace.params.ton_proof);
                }
                (0, utils_1.logDebug)("tonprovider connect params: ", JSON.stringify(params));
                try {
                    let tonResult = yield window.okxTonWallet.tonconnect.connect(2, params);
                    (0, utils_1.logDebug)("tonprovider connect tonResult: ", JSON.stringify(tonResult));
                    this.signalChainConnectResult = tonResult;
                    return tonResult;
                }
                catch (error) {
                    (0, utils_1.logDebug)("tonprovider connect error: ", JSON.stringify(error));
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "tonconnect error");
                }
            }
            else {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, "manifestUrl or params is nil");
            }
        });
    }
    singleConnect(nameSpace, dappInfo) {
        return this.connect(nameSpace, dappInfo);
    }
    addListener(accountChangeListener) {
        console.log("window.okxwallet configEventWithKey:", 'ton');
        this.accountChangedTONHandler = () => {
            console.log("window.okxwallet configEventWithKey_TON:", Date.now(), 'ton');
            accountChangeListener();
        };
        window.okxTonWallet.tonconnect.on('accountChanged', this.accountChangedTONHandler);
    }
    removeListener() {
        if (this.accountChangedTONHandler) {
            window.okxTonWallet.tonconnect.off('accountChanged', this.accountChangedTONHandler);
        }
    }
}
exports.TONProvider = TONProvider;
